import { createReducer, on } from '@ngrx/store';
import { setRedirectUrl } from './redirect-url.actions';

export const initialState = null;

export const redirectUrlReducer = createReducer(
  initialState,

  on(setRedirectUrl, (state, { redirectUrl }) => redirectUrl),

);
